import { Route } from 'vue-router';
import { mapActions, mapGetters } from 'vuex';

import { ApiEnum } from '../enums';

import { GuardResolveFunction } from '../models';

import { ANALYTICS_CONSTS } from '../store/analytics/analytics.consts';
import { CONTEXT_CONSTS } from '../store/context/context.consts';

export const InsightsMixin = {
  props: {
    loading: Object
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    })
  },
  data: function () {
    return {
      data: undefined,
      contextWatchDisabled: false,
      previousContext: undefined
    };
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      fetchStatsReport: ANALYTICS_CONSTS.actions.fetchStatsReport
    }),
    loadData: async function (cleanData = true, ...args: unknown[]): Promise<void> {
      this.$emit('updateLoading', { visible: true });
      try {
        this.data = await this.fetchData(cleanData, ...args);
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.STATS));
        this.data = undefined;
      } finally {
        this.$emit('updateLoading', { visible: false });
      }
    },
    fetchData: function (cleanData: boolean, ...args: unknown[]): Promise<any> { return; },
    onContextChange: async function (): Promise<void> {
      await this.loadData();
    }
  },
  watch: {
    context: {
      handler: async function (): Promise<void> {
        if (!this.contextWatchDisabled) {
          await this.onContextChange();
        }
        this.previousContext = { ...this.context };
      },
      deep: true,
      immediate: true
    }
  },
  beforeRouteLeave: function (to: Route, from: Route, next: GuardResolveFunction): void {
    this.contextWatchDisabled = true;
    next();
  }
};
